import { render, staticRenderFns } from "./ChildWorkshops.vue?vue&type=template&id=19bc9ef8"
import script from "./ChildWorkshops.vue?vue&type=script&lang=ts"
export * from "./ChildWorkshops.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports